import { render, staticRenderFns } from "./AgentPermissionsItem.vue?vue&type=template&id=0bb65d66"
import script from "./AgentPermissionsItem.vue?vue&type=script&lang=js"
export * from "./AgentPermissionsItem.vue?vue&type=script&lang=js"
import style0 from "./AgentPermissionsItem.vue?vue&type=style&index=0&id=0bb65d66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports